import React from 'react'
import PropTypes from 'prop-types'

import { useToggleFocus } from 'hooks'

import ThemeWrapper from './ThemeWrapper'
import EntryProviders from 'components_v2/_entryPoints/EntryProviders'

const StyledWrapper = ({ user, children, ...rest }) => {

  // Because StyledWrapper is on StyledHeader, and StyledHeader loads on all pages (except Admin), we only need to attach global   event listeners here.
  useToggleFocus()

  return (
    <EntryProviders user={user}>
      <ThemeWrapper color='primary' {...rest} >
        {children}
      </ThemeWrapper>
    </EntryProviders>
  )
}

StyledWrapper.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node.isRequired
}

export default StyledWrapper
